module.exports = __webpack_public_path__ + "assets/webgl/360_vignes.jpg.66c24dd7.webp";